import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { reportSystemError } from "@/lib/monitoring";

export class AppErrorBoundary extends React.Component<React.PropsWithChildren, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    void reportSystemError(error, { source: "react", componentStack: info.componentStack });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="flex min-h-screen items-center justify-center bg-background p-6">
        <section className="w-full max-w-md rounded-md border bg-card p-6 text-center shadow-sm">
          <AlertTriangle className="mx-auto mb-3 h-8 w-8 text-destructive" />
          <h1 className="text-lg font-semibold">Não foi possível abrir esta tela</h1>
          <p className="mt-2 text-sm text-muted-foreground">O erro foi registrado com a unidade e o navegador em uso.</p>
          <Button className="mt-5" onClick={() => window.location.reload()}><RefreshCw className="mr-2 h-4 w-4" /> Recarregar</Button>
        </section>
      </main>
    );
  }
}
